/**
 * ConnectionStatusBadge Component
 * Displays the status of a calendar connection with colored badge.
 */

import { CalendarConnectionStatus } from '@signalvote/shared';
import { cn } from '@/lib/utils';

interface ConnectionStatusBadgeProps {
  status: CalendarConnectionStatus;
  className?: string;
}

const statusConfig: Record<
  CalendarConnectionStatus,
  { label: string; bgClass: string; textClass: string }
> = {
  [CalendarConnectionStatus.Active]: {
    label: 'Active',
    bgClass: 'bg-green-100',
    textClass: 'text-green-800',
  },
  [CalendarConnectionStatus.TokenExpired]: {
    label: 'Expired',
    bgClass: 'bg-yellow-100',
    textClass: 'text-yellow-800',
  },
  [CalendarConnectionStatus.Revoked]: {
    label: 'Revoked',
    bgClass: 'bg-red-100',
    textClass: 'text-red-800',
  },
  [CalendarConnectionStatus.Error]: {
    label: 'Error',
    bgClass: 'bg-red-100',
    textClass: 'text-red-800',
  },
};

export function ConnectionStatusBadge({ status, className }: ConnectionStatusBadgeProps) {
  const config = statusConfig[status];

  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium',
        config.bgClass,
        config.textClass,
        className
      )}
    >
      {config.label}
    </span>
  );
}

export default ConnectionStatusBadge;
